import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;
